import { useContext, useEffect, useState } from 'react'

import PromoContext from '@/context/promo/context'
import { calcDiscountedPrice, isPromoValid } from '@/utils'

export type DiscountPrice = number | undefined

/**
 * Calculate the discounted listing price for a UTM promo code.
 *
 * @param price - The original listing price.
 *
 * @returns The discounted listing price or `undefined` if there is no promo.
 */
export const usePromoPrice = (price: number, listingQuantity: number) => {
    const {
        selectors: { promo },
    } = useContext(PromoContext)

    const [discountPrice, setDiscountPrice] = useState<DiscountPrice>()

    const quantity = listingQuantity || 1

    useEffect(() => {
        if (!promo || !isPromoValid(promo)) return

        const { amountType: type, amount: promoAmount, maxAmount: max, minTotal } = promo

        const promoPrice = calcDiscountedPrice({ promoAmount, max, price, quantity, type, minTotal })

        setDiscountPrice(promoPrice)
    }, [promo, price, quantity])

    return discountPrice
}
